import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import Tag from "app/components/ui/Tag/Tag";
import "./PriceTag.scss";

export const PRICE_TAG_VARIANTS = {
	INCLUDED: "included",
	OFFERED: "offered",
} as const;

export type PriceTagVariant = (typeof PRICE_TAG_VARIANTS)[keyof typeof PRICE_TAG_VARIANTS];

const LABEL_ID_BY_VARIANT: Record<PriceTagVariant, string> = {
	[PRICE_TAG_VARIANTS.INCLUDED]: "general.included",
	[PRICE_TAG_VARIANTS.OFFERED]: "general.offered",
};

type PriceTagProps = {
	variant?: PriceTagVariant;
	className?: string;
};

const PriceTag = ({ variant = PRICE_TAG_VARIANTS.INCLUDED, className }: PriceTagProps) => (
	<Tag
		isBold
		className={classNames("price-tag", `price-tag--${variant}`, className)}
		data-testid={`${variant}-tag`}
	>
		<FormattedMessage id={LABEL_ID_BY_VARIANT[variant]} />
	</Tag>
);

export default PriceTag;
